<script async setup>
import { defineProps, useAttrs, defineEmits, computed } from "vue";
import KdFormElement from "./KdFormElement.vue";

const props = defineProps({
    error: {
        type: String,
        default: "",
    },
    label: {
        type: String,
        default: "",
    },
    name: {
        type: String,
        default: "",
    },
    readonly: {
        type: Boolean,
        default: false,
    },
    required: {
        type: Boolean,
        default: false,
    },
    selected: {
        type: Boolean,
        default: false,
    },
    value: {
        type: String,
        default: "",
    },
});

const emit = defineEmits(["change", "update:selected"]);
const attrs = useAttrs();

const localChecked = computed({
  get: () => !!props.selected,
  set: (v) => {
    emit("update:selected", v);
    emit("change", v);
  },
});
</script>

<template>
    <KdFormElement
        :label="props.label"
        :error="props.error"
        :required="props.required"
    >
        <div class="flex items-start text-sm px-2 py-1 hover:bg-ts-light cursor-pointer">
            <div
                class="rounded shadow-sm size-3 mt-0.5 mr-2 border relative overflow-hidden flex justify-center items-center shrink-0"
                :class="{
                    'border-black': !props.error,
                    'border-red': props.error,
                }"
            >
                <input
                    v-model="localChecked"
                    type="checkbox"
                    class="peer absolute opacity-0 left-0 top-0 size-full cursor-pointer"
                    :name="props.name"
                    :value="props.value"
                    :readonly="props.readonly"
                    :required="props.required"
                    v-bind="attrs"
                >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 16"
                    fill="none"
                    stroke="black"
                    stroke-width="2"
                    class="hidden peer-checked:block pointer-events-none"
                >
                    <path d="M3 8l3 3 7-7" />
                </svg>
            </div>
            <span :class="{ 'text-red': props.error }">
                <slot />
            </span>
        </div>
    </KdFormElement>
</template>
